import { Button } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var submitSuccess = function submitSuccess(t) {
  return {
    severity: 'success',
    message: t('Your changes have been saved'),
    duration: 'medium'
  };
};
export var imageSubmitSuccess = function imageSubmitSuccess(t) {
  return {
    severity: 'success',
    message: t('Your profile image has been saved'),
    duration: 'medium'
  };
};
export var imageRemoveSuccess = function imageRemoveSuccess(t) {
  return {
    severity: 'success',
    message: t('Your profile image has been removed'),
    duration: 'medium'
  };
};
export var submitFailure = function submitFailure(onRetry, t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to save your changes'),
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: t('Retry')
    })
  };
};
export var imageUploadFailure = function imageUploadFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to upload your photo'),
    duration: 'medium'
  };
};
export var imageRemoveFailure = function imageRemoveFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to remove your photo'),
    duration: 'medium'
  };
};
export var imageSubmitFailure = function imageSubmitFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to save your profile image'),
    duration: 'medium'
  };
};